import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { UserType } from "@/constants";
import type {
  RegistrantLicenseListLicenseResponseSchema,
  RegistrantLicenseListQuestionColumnSchema,
} from "@/hera-api/client/types.gen";
import { LicenseTable } from "./license-table";

interface JurisdictionCardProps {
  jurisdiction: string;
  licenses: RegistrantLicenseListLicenseResponseSchema[];
  userType: UserType;
  showRegistrantColumn?: boolean;
  /** Column visibility (shared across all jurisdiction boxes) */
  columnVisibility?: Record<string, boolean>;
  /** Column filters (shared across all jurisdiction lists) */
  columnFilters?: Record<string, string[]>;
  onColumnFiltersChange?: (filters: Record<string, string[]>) => void;
  facetedValuesByColumn?: Record<string, string[]>;
  onLicenseRowClick?: (licenseId: string) => void;
  questionColumns?: RegistrantLicenseListQuestionColumnSchema[];
}

export function JurisdictionCard({
  jurisdiction,
  licenses,
  userType,
  showRegistrantColumn = false,
  columnVisibility,
  columnFilters,
  onColumnFiltersChange,
  facetedValuesByColumn,
  onLicenseRowClick,
  questionColumns = [],
}: JurisdictionCardProps) {
  return (
    <Card key={jurisdiction} className="min-w-0">
      <CardHeader className="px-4 md:px-6">
        <div className="flex items-center justify-between">
          <CardTitle className="font-krona-one uppercase text-xl leading-none tracking-tight font-bold">
            {jurisdiction}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent className="min-w-0 px-4 md:px-6">
        <LicenseTable
          licenses={licenses}
          userType={userType}
          showRegistrantColumn={showRegistrantColumn}
          columnVisibility={columnVisibility}
          columnFilters={columnFilters}
          onColumnFiltersChange={onColumnFiltersChange}
          facetedValuesByColumn={facetedValuesByColumn}
          onLicenseRowClick={onLicenseRowClick}
          questionColumns={questionColumns}
          scrollWithPage
        />
      </CardContent>
    </Card>
  );
}
